// export const appConfig = {
//     rootUrl: 'https://wem-dev.emro.who.int/kpireportsapi',
//     apiUrl: 'https://wem-dev.emro.who.int/kpireportsapi/api/'
//  }

export const appConfig = {
  rootUrl: 'https://kpireport.emro.who.int/kpireportsapi',
 apiUrl: 'https://kpireport.emro.who.int/kpireportsapi/api/'
}

// export const appConfig = {
//     rootUrl: 'https://aps-test2.emro.who.int/kpireportsapi',
//     apiUrl: 'https://aps-test2.emro.who.int/kpireportsapi/api/'
//  }



// export const appConfig = {
//    rootUrl: 'https://wem-apps.emro.who.int/kpireportsapi',
//    apiUrl: 'https://wem-apps.emro.who.int/kpireportsapi/api/'
// }

// export const appConfig = {
//   rootUrl: 'https://localhost:5001/',
//     apiUrl: 'https://localhost:5001/api/'
//             }

// export const appConfig = {
//   rootUrl: 'https://localhost:44302/',
//     apiUrl: 'https://localhost:44302/api/'
//             }
